export const SUPPORT_STATUS = {
  IN_WORK: 0,
  ACCEPTED: 3,
  DONE: 5,
  CANCEL: 10,
}

export const getSupportStatusTabs = (authorType) => {
  const doneLabel = authorType === 'student' ? 'Принято' : 'Выполнено'

  return [
    { label: 'В работе', value: SUPPORT_STATUS.IN_WORK },
    { label: doneLabel, value: SUPPORT_STATUS.DONE },
    { label: 'Отклонено', value: SUPPORT_STATUS.CANCEL },
  ]
}

export const getDocumentDisplayName = (document) => {
  const documentName = String(document?.document_name ?? '').trim()

  if (documentName) return documentName

  return document?.name ?? ''
}

const getFileExtension = (filePath) => {
  const cleanPath = String(filePath ?? '').split('?')[0]
  const parts = cleanPath.split('.')
  if (parts.length < 2) return ''

  const extension = parts.pop()?.trim().toLowerCase() ?? ''
  return extension && extension.length <= 8 ? extension : ''
}

export const resolveSupportAttachmentFileName = (displayName, fileUrl) => {
  const normalizedName = String(displayName ?? '').trim() || 'Документ'
  if (normalizedName.includes('.')) return normalizedName

  const extension = getFileExtension(fileUrl)
  return extension ? `${normalizedName}.${extension}` : normalizedName
}

export const downloadSupportAttachment = (fileUrl, fileName) => {
  const link = document.createElement('a')
  link.href = fileUrl
  link.download = resolveSupportAttachmentFileName(fileName, fileUrl)
  link.target = '_blank'
  link.rel = 'noreferrer'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
